import { useProfileQuery } from "../react-query/profile";
import { useEffect, useState } from "react";
import { useGetRoleQuery } from "../react-query/setting/role.js";
import { initialAcl, superAdmin } from "../../constants/acl";



const useAccessLevels = () => {

    const [loading, setLoading] = useState(true)
    const [perms, setPerms] = useState(initialAcl)

    /**
     * user role
     */
    const [role, setRole] = useState(null)

    /**
     * getting current user role details - (permissions)
     */
    const { data: permissions, refetch: getRole } = useGetRoleQuery(role)

    const permit = () => {

        if (permissions) {
            let temp = initialAcl
            permissions.permissions.forEach(perm => {
                const activity = perm.activity
                const scope = perm.scope

                if (scope in temp) {
                    temp[scope].read = activity.read
                    temp[scope].write = activity.write
                }
            })
            setLoading(false)
            setPerms(temp)
        }
    }

    useEffect(permit, [permissions])

    /**
     * profile
     */
    const onProfileSuccess = (res) => {
        setRole("admin") // !-- HARD CODED
    }
    useProfileQuery(onProfileSuccess)

    useEffect(() => {
        if (role) {
            if (role !== 'admin') getRole()
            else {
                setLoading(false)
                setPerms(superAdmin)
            }
        }
    }, [role])

    const reset = () => setRole(null)

    return {
        permissions: perms,
        loading,
        reset,
        setRole
    }
}

export {
    useAccessLevels
}
